/* eslint-disable react-doctor/only-export-components */
import {
	createFileRoute,
	Outlet,
	useRouterState,
} from "@tanstack/react-router";
import type * as React from "react";
import { ApiDocsLayout } from "@/components/developers/api-docs-layout";
import { ApiDocsToolbar } from "@/components/developers/api-docs-toolbar";
import { DocsSidebarMobileBridge } from "@/components/docs/docs-center-layout";
import { DocsSiteNav } from "@/components/docs/docs-site-nav";
import Header from "@/components/Header";
import { SidebarProvider } from "@/components/ui/sidebar";
import { DOCS_API_REFERENCE_PATH } from "@/lib/docs-paths";

export const Route = createFileRoute("/_docs")({
	component: DocsRouteLayout,
});

function DocsRouteLayout() {
	const isApiReference = useRouterState({
		select: (state) =>
			state.location.pathname.startsWith(DOCS_API_REFERENCE_PATH),
	});

	return (
		<div className="isolate flex h-dvh flex-col bg-background text-foreground">
			<Header />
			<DocsSiteNav />
			<SidebarProvider
				className="flex min-h-0 flex-1 flex-col"
				style={
					{
						"--sidebar-width": "22rem",
					} as React.CSSProperties
				}
			>
				<DocsSidebarMobileBridge />
				{isApiReference ? (
					<div className="flex min-h-0 min-w-0 flex-1 flex-col">
						<ApiDocsToolbar />
						<ApiDocsLayout>
							<Outlet />
						</ApiDocsLayout>
					</div>
				) : (
					<Outlet />
				)}
			</SidebarProvider>
		</div>
	);
}
